<template>
  <div class="home">
    <div class="home-left">
      <div class="left-menu">
        <Menu />
      </div>
    </div>
    <div class="home-right">
      <Function />
    </div>

  </div>
  <router-view></router-view>

</template>
<script>
  // import FingerprintJS from '@fingerprintjs/fingerprintjs'
  import Menu from '../components/pc/menu.vue'
  import Function from '../components/pc/function.vue'
  import Login from '../components/login/index.vue'
  import failConvert from "../components/common/failConvert.vue";
  export default {
    name: 'App',
    data() {
      return {
        radio: '1',
        langShow: '',

        percent: 0,
        show: false,
        lineStatus: true
      }
    },
    computed: {
      getAppStore() {
        return this.$store.state.appState
      }
    },
    methods: {

    },
    watch: {

    },
    components: {
      Menu,
      Login,
      Function,
      failConvert
    },
    mounted() {
      console.log("pc端");
      // console.log("=========:", this.$VERSION);
      // if (!localStorage.getItem('deviceId')) {
      // FingerprintJS.load().then(fp => {
      //   fp.get().then(result => {
      //     this.$store.commit('setDeviceId', result.visitorId)
      //     localStorage.setItem('deviceId', result.visitorId)
      //     console.log('获取设备唯一标识：', result.visitorId);
      //   });
      // });
      // }
      // window.addEventListener('scroll', this.scrollDs, true)
      // // window.addEventListener('beforeunload', (e) => this.beforeunloadFn(e))
      // // this.$cookies.isKey('pdfToken') ? this.$store.commit('changePdfToken', this.$cookies.get('pdfToken')) : this.getPdfToken()
      // let myDate = new Date()
      // if (localStorage.getItem("user_views") && localStorage.getItem("user_views") != myDate.toLocaleString().substring(0, 9)) {
      //   this.$gtag.event("user_views", {
      //     event_category: "pageviews",
      //     event_label: "old",
      //   });
      //   localStorage.setItem("user_views", myDate.toLocaleString().substring(0, 9))
      // } else if (!localStorage.getItem("user_views")) {
      //   localStorage.setItem("user_views", myDate.toLocaleString().substring(0, 9))
      //   this.$gtag.event("user_views", {
      //     event_category: "pageviews",
      //     event_label: "new",
      //   });
      // }
      // this.$store.commit('changeStateLocationHref', window.location.href)
      // this.offlineF = () => {
      //   console.log("------------========error");
      //   this.lineStatus = false
      // };
      // this.onlineF = () => {
      //   console.log("online");
      //   this.lineStatus = true
      // };
      // window.addEventListener("offline", this.offlineF);
      // window.addEventListener("online", this.onlineF);
    },
    created() {
    },
    unmounted() {
      // window.removeEventListener('beforeunload', (e) => this.beforeunloadFn(e))
    }
  }
</script>

<style lang="scss" scoped>
  .home {
    width: 1224px;
    /* height: 592px; */
    display: flex;
  }

  .home-left {
    width: 220px;
    /* height: 592px; */
    /* background-image:; */

    background: #F5F7FD url(../assets/menu/back.png);
    margin-top: -44px;

    .left-menu {
      margin-top: 68px;
    }
  }

  .home-right {
    width: 1004px;
    /* height: 592px; */
    display: flex;
    flex-direction: column;
  }
</style>
<style lang="scss" scope>
  img {
    -webkit-user-drag: none;
  }

  .alertSpan {
    margin-left: 12px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;

    color: rgba(29, 29, 31, 0.7);
  }

  .cancleBtn {
    display: none !important;
  }

  #app {
    /* font-family: Avenir, Helvetica, Arial, sans-serif; */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
    /* font-family: 'Be Vietnam Pro', sans-serif; */
    color: #001637;

    h2 {
      margin: 0;
    }

    ul {
      margin: 0;
      padding: 0;
    }
  }

  .show {
    display: none !important;
  }

  .active {
    display: block !important;
  }

  .el-backtop {
    background-color: rgb(0, 0, 0, 0) !important;
    box-shadow: none !important;
    bottom: 45px !important;
    right: 12px !important;
    z-index: 10 !important;
  }

  .footer a:hover {
    color: #fff !important;
    text-decoration: underline;
  }

  p {
    margin-bottom: 0;
  }

  li {
    list-style-type: none;
  }

  .flexible {
    display: flex;
  }

  .flex-justify-between {
    justify-content: space-between;
  }

  .flex-wrap {
    flex-wrap: wrap;
  }

  #fun-area {
    padding-top: 64px;
    /* // padding-bottom: 80px; */
    background: url('data:image/svg+xml;base64,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');
    background-size: cover;
    height: 568px;

    .editBox {
      max-width: 1224px;
      margin: 72px auto auto auto;
      position: relative;
      height: 548px;
      display: flex;
      box-shadow: 0px 10px 16px rgb(84 82 246 / 8%);
      border-radius: 16px;
    }
  }

  #fun-area.showTop {
    padding-top: 100px;
  }

  .fun-area-wrap {
    width: 100%;

    .el-upload,
    .upload-area,
    .grid-content {
      height: 100%;
    }

    .el-upload,
    .el-upload-dragger {
      /* width: 100%; */
      width: 1176px;
      height: 500px;
    }

    .upload-area {
      .el-upload {
        .el-upload-dragger {
          height: 100%;
          /* padding: 24px; */
          padding-top: 40px;
          border: 2px dashed #eaeaea;
          border-radius: 12px;

          &:hover {
            border: 2px dashed #cccbfc;
          }

          &:active {
            border: 2px dashed #cccbfc;
          }

          &:focus {
            border: 2px dashed #5452f6;
            background-color: red;
          }
        }
      }
    }
  }
</style>